import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { addNewRelicPageAction } from 'ddc-new-relic';
import './EventViewer.scss';

// drag it around: https://www.kirupa.com/html5/drag.htm

const handleBeforeUnload = (event) => {
	const e = event;
	e.returnValue = 'Are you sure you want to leave?';
};

export default function EventViewer(props) {
	useEffect(() => {
		// monitor usage of eventViewer fuctionality
		// if there is a huge spike in activity could be a bug in how it shows
		addNewRelicPageAction('ws-tagging-event-viewer');
		window.addEventListener('beforeunload', handleBeforeUnload);
		return () =>
			window.removeEventListener('beforeunload', handleBeforeUnload);
	}, []);

	return ReactDOM.createPortal(
		<div className="ws-tagging-event-viewer" placeholder="EventViewer">
			<div
				className="ws-tagging-close-button"
				onClick={() => {
					const parentElem = document.querySelector(
						'.ws-tagging-event-viewer'
					);
					parentElem.classList.toggle(
						'ws-tagging-event-viewer--hidden'
					);
				}}
				role="button"
				aria-hidden="true" // sorry screen readers
			>
				TGG
			</div>
			{props.data.map(({ detail, eventViewerCount }) => (
				<div key={eventViewerCount}>
					<div>{eventViewerCount}</div>
					<pre>{JSON.stringify(detail, null, 2)}</pre>
				</div>
			))}
		</div>,
		document.getElementsByTagName('body')[0]
	);
}

EventViewer.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape)
};

// only export if the test framework is running
export const exportedForTesting = {
	...(typeof test !== 'undefined' && {
		handleBeforeUnload
	})
};
